/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import StsAkVo from './StsAkVo';




  /**
   * The TextbookVersionStsAkVo model module.
   * @module textbook/model/TextbookVersionStsAkVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextbookVersionStsAkVo</code>.
   * @alias module:textbook/model/TextbookVersionStsAkVo
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>TextbookVersionStsAkVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextbookVersionStsAkVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextbookVersionStsAkVo} The populated <code>TextbookVersionStsAkVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbookId')) {
        obj['textbookId'] = ApiClient.convertToType(data['textbookId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditStatus')) {
        obj['auditStatus'] = ApiClient.convertToType(data['auditStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'stsAk')) {
        obj['stsAk'] = StsAkVo.constructFromObject(data['stsAk']);
      }
    }
    return obj;
  }

  /**
   * 版本id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 教材id
   * @member {Integer} textbookId
   */
  exports.prototype['textbookId'] = undefined;
  /**
   * 申请发布说明
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 0待审核；
   * @member {Integer} auditStatus
   */
  exports.prototype['auditStatus'] = undefined;
  /**
   * 上传凭证
   * @member {module:textbook/model/StsAkVo} stsAk
   */
  exports.prototype['stsAk'] = undefined;



  export default exports;
;


